import { Switch as BaseSwitch, SwitchProps } from 'antd';
import style from './index.module.scss';

type TSwitch = {
  label: string | JSX.Element;
} & SwitchProps;
export const Switch = ({ label, ...props }: TSwitch) => {
  return (
    <div className={`${style.switch} ${props.className}`}>
      <BaseSwitch {...props} />
      {label}
    </div>
  );
};
